import { useEffect } from "react";

export const ContextMenu = ({ x, y, items, onClose }) => {
  useEffect(() => {
    const handler = () => onClose();
    window.addEventListener("click", handler);
    window.addEventListener("resize", handler);
    window.addEventListener("scroll", handler, true);
    return () => {
      window.removeEventListener("click", handler);
      window.removeEventListener("resize", handler);
      window.removeEventListener("scroll", handler, true);
    };
  }, [onClose]);

  const pos = {
    left: Math.min(x, window.innerWidth - 210),
    top: Math.min(y, window.innerHeight - items.length * 40 - 20),
  };

  return (
    <div
      data-testid="context-menu"
      className="fixed z-[200] min-w-[200px] py-1.5 bg-white border border-stone-200 rounded-lg shadow-xl"
      style={pos}
      onContextMenu={(e) => e.preventDefault()}
    >
      {items.map((item) => (
        <button
          key={item.label}
          data-testid={`context-menu-${item.testId}`}
          onClick={() => {
            onClose();
            item.action();
          }}
          className={`w-full text-left px-4 py-2 text-sm transition-colors duration-150 hover:bg-stone-100 ${item.danger ? "text-red-600 hover:bg-red-50" : "text-stone-700"}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};
